module.exports = __webpack_public_path__ + "static/teck_1-56041f5c49fa700ec0d8ca34e589c06f.jpg";